import { configureApiClient } from '@/lib/api';
import { useNavigate } from '@solidjs/router';
import { type JSX, onMount } from 'solid-js';
import { useAuth } from './AuthProvider';
import { signOutOfFirebase } from './signInWithGoogle';

/**
 * Bridges the auth context + router to the API client side-effects:
 *  - 401 → sign out Firebase + navigate /login?reason=expired
 *  - 403 EMAIL_NOT_AUTHORIZED → record rejected email + navigate /authorize-error
 *
 * Must be mounted inside both <Router> (for useNavigate) and <AuthProvider>.
 */
export const ApiClientBridge = (props: { children: JSX.Element }): JSX.Element => {
  const navigate = useNavigate();
  const { setRejected } = useAuth();

  onMount(() => {
    configureApiClient({
      navigate: (path: string) => navigate(path),
      onUnauthenticated: async () => {
        await signOutOfFirebase().catch(() => {
          /* best-effort */
        });
      },
      onEmailNotAuthorized: (email) => {
        if (email) setRejected({ email });
      },
    });
  });

  return <>{props.children}</>;
};
